module.exports = __webpack_public_path__ + "assets/760bb9694abc7214672b5fb433b8a69e.svg";